import { motion } from 'framer-motion';
import { Button } from './ui/button';
import { Send, CheckCircle } from 'lucide-react';
import { useGateModal } from '../hooks/useGateModal';

const trustPoints = [
  'Gratis akses grup dan bot AI',
  'Analisis chart XAUUSD real-time',
  'Bukan auto-trading, bukan copy trade',
  'Fokus edukasi dan manajemen risiko',
];

const CTASection = () => {
  const { openGate } = useGateModal();

  return (
    <section
      className="py-24 md:py-32 relative overflow-hidden"
      data-testid="cta-section"
    >
      {/* Background gradient */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom,_var(--tw-gradient-stops))] from-tc-primary/20 via-tc-bg to-tc-bg" />

      <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-12 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-6 leading-tight">
            Mulai analisis chart{' '}
            <span className="text-tc-primary">XAUUSD</span> sekarang
          </h2>

          <p className="text-xl text-tc-text-secondary mb-12 max-w-2xl mx-auto">
            Jawab quiz singkat, temukan strategi Anda, dan langsung gunakan bot AI. Gratis.
          </p>

          {/* Dual CTA Buttons */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: 0.3 }}
            className="flex flex-col sm:flex-row justify-center gap-4 mb-6"
          >
            <Button
              onClick={openGate}
              className="bg-tc-primary hover:bg-tc-primary-hover text-white px-10 py-8 text-xl font-bold tracking-wider rounded-full btn-glow"
              data-testid="cta-telegram-btn"
            >
              <Send className="w-6 h-6 mr-3" />
              CARI TAHU GAYA TRADING ANDA
            </Button>
          </motion.div>

          <p className="text-sm text-tc-text-secondary mb-10">
            Gratis. Langsung akses bot AI di Telegram. Trading mengandung risiko.
          </p>

          {/* Trust Points */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.5 }}
            className="flex flex-wrap justify-center gap-6"
          >
            {trustPoints.map((point, idx) => (
              <div key={idx} className="flex items-center gap-2">
                <CheckCircle className="w-5 h-5 text-tc-secondary" />
                <span className="text-tc-text-secondary">{point}</span>
              </div>
            ))}
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
